
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/convert/buy",
      function () {
        return require("private-next-pages/convert/buy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/convert/buy"])
      });
    }
  